
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import formDataReducer from './supplierFormDataSlice';
import buyerFormDataReducer from './buyerFormDataSlice'
import personalInfoFormDataReducer from './personalInfoSlice';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import tabDataReducer from './tabSlice';
import suppliersReducer from './suppliersManagementSlice';
import marketplaceSuppliersReducer from './supplierMarketplaceSlice'
import rfpReducer from "./rfpSlice";
import engagementMetricsReducer from './engagementMetricsSlice';
import formResponsesReducer from './formResponsesSlice';
import formsReducer from './formsSlice';
import messagesReducer from "./messagesSlice";
import scoreCardReducer from './scoreCardSlice'
import metricsReducer from "./metricsSlice";
import paramsReducer from "./ParamSlice"
import dashboardReducer from './dashboardSlice';
import engagementAnalyticsReducer from './engagementAnalyticsSlice';
import adminTenantsReducer from './adminTenantsSlice';
import invitationReducer from './InvitationSlice';

const authPersistConfig = {
  key: 'auth',
  storage,
};

const formDataPersistConfig = {
  key: 'formData',
  storage,
};
const buyerFormDataPersistConfig = {
  key: 'buyerFormData',
  storage,
};

const persistedAuthReducer = persistReducer(authPersistConfig, authReducer);
const persistedFormDataReducer = persistReducer(formDataPersistConfig, formDataReducer);
const persistedBuyerFormDataReducer = persistReducer(buyerFormDataPersistConfig, buyerFormDataReducer);
const store = configureStore({
  reducer: {
    auth: persistedAuthReducer,
    formData: persistedFormDataReducer,
    buyerFormData: persistedBuyerFormDataReducer,
    personalInfoFormData: personalInfoFormDataReducer,
    tabs: tabDataReducer, 
    suppliers: suppliersReducer,
    marketplaceSuppliers: marketplaceSuppliersReducer,
    rfp: rfpReducer,
    engagementMetrics: engagementMetricsReducer,
    formResponses: formResponsesReducer,
    forms: formsReducer,
    messages: messagesReducer,
    scoreCard: scoreCardReducer,
    metrics: metricsReducer,
    params: paramsReducer,
    dashboard: dashboardReducer,
    engagementAnalytics: engagementAnalyticsReducer,
    adminTenants: adminTenantsReducer,
    invitation: invitationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
export const persistor = persistStore(store);
export default store;
